import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import Content from './Content'
import { useTimeBalanceTimePeriodDetails } from './useTimeBalanceTimePeriodDetails'

interface Props {
  open: boolean
  onClose: () => void
  dateFrom: string
  dateTo: string
  locationsIds: number[]
  teamsIds: number[]
}

const TimeInsightsSidepanel = ({
  open,
  onClose,
  dateFrom,
  dateTo,
  locationsIds,
  teamsIds,
}: Props) => {
  const title = i18n.t('shift_management.time_insights.title')
  const modalTitle = i18n.t('shift_management.time_insights.loading_modal.title')
  const modalDescription = i18n.t('shift_management.time_insights.loading_modal.description')

  const { loading, timePeriodDetails, refetch } = useTimeBalanceTimePeriodDetails({
    variables: {
      ids: [],
      dateFrom: dateFrom,
      dateTo: dateTo,
      locationsIds: locationsIds,
      teamsIds: teamsIds,
    },
  })

  return (
    <>
      {loading ? (
        <Modal illustration="document-edit" title={modalTitle} description={modalDescription} />
      ) : (
        <Sidepanel
          title={title}
          open={open}
          onClose={onClose}
          closeLabel={i18n.t('common.close')}
          overlay={false}
          width="wideXL"
        >
          <Content
            timePeriodDetails={timePeriodDetails}
            locationsIds={locationsIds}
            teamsIds={teamsIds}
            refetch={refetch}
            loading={loading}
          />
        </Sidepanel>
      )}
    </>
  )
}

export default observer(TimeInsightsSidepanel)
